import { useQuery } from 'react-query';

import { CYCLES } from 'querykeys';

import { Cycle } from 'types/Cycle';
import api from 'utils/api';

type CyclesResponse = { cycles: Cycle[] };
export const useCyclesQuery = () => {
  return useQuery<CyclesResponse>([CYCLES], api.getCyclesRequest, {
    staleTime: 10 * 60 * 1000, // cache cycles for 10 minutes
  });
};

type CycleMap = { [startDate: string]: { [endDate: string]: Cycle } };

/**
 * Use react-query cache to memoise a map of cycles, keyed by start date and end date
 *
 * meant to speed up lookups like "which cycle does this entity belong to?"
 */
export const useCycleMapQuery = () => {
  const transformToCycleMap = (data: CyclesResponse) => {
    return data.cycles.reduce((acc, cycle) => {
      acc[cycle.startDate] = {
        ...acc[cycle.startDate],
        [cycle.endDate]: cycle,
      };
      return acc;
    }, {} as CycleMap);
  };

  return useQuery<CycleMap>(
    [CYCLES, 'map'],
    async () => {
      const response = await api.getCyclesRequest();
      // transform the response inside the fetch call to benefit from cache
      return transformToCycleMap(response);
    },
    {
      staleTime: 10 * 60 * 1000, // cache cycles for 10 minutes
    }
  );
};
